import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../Service/index';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  model: any = {};
  returnUrl: string;
  errorMsg = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
  ) { }

  ngOnInit() {
    // reset login status
    this.authenticationService.logout();

  }

  login() {
    this.authenticationService.login(this.model.username, this.model.password)
      .subscribe(
        data => {
          // Data from backend is not null
          if(data[0]){
            // console.log(data[0]);
            // Set localStorage to store login status and school name
            localStorage.setItem('school', JSON.stringify(data[0].id));
            localStorage.setItem('name', data[0].name);
            this.errorMsg = "";
            this.router.navigate(['/home']);
          }
          // Data is null, means no username and passord in database.
          else{
            this.errorMsg = "wrong username or password";
          }

        });
  }


}



// WEBPACK FOOTER //
// /home/hihoo/ibilling/attendence/public/src/app/login/login.component.ts